import dayjs from "dayjs";

export const formatDate = (
  dateArg,
  which,
  setStartDate,
  setEndDate
) => {
  if (dateArg) {
    const date = dayjs(dateArg).format("YYYY-MM-DD HH:mm:ss");
    const sendDateFormat = dayjs(dateArg).format("YYYY-MM-DD");
    const dateWithSeconds = dayjs(dateArg).second(59);
    const endDateFormat = dateWithSeconds.format("YYYY-MM-DD HH:mm:ss");
    if (which === "start") {
      setStartDate(date);
    } else {
      setEndDate(endDateFormat);
    }
  }
};
